import { GroupIds } from "@/configuration/group-ids";
import type { CustomerSmsRoutingConfig } from "@/customer-interface/sms-routing";
import { HEARTPLACE_SANDBOX_TWILIO_NUMBER } from "@/packages/shared/src/group-configs/groups";

export { HEARTPLACE_SANDBOX_TWILIO_NUMBER };

export const HEARTPLACE_TWILIO_NUMBER = "+18178579538";
export const HEARTPLACE_TRANSFER_LINE = "+19723789560";

export const heartplaceSmsRoutingConfig = {
  groups: [
    {
      groupId: GroupIds.USHV_HEARTPLACE_LIVE,
      inboundPhoneNumbers: [HEARTPLACE_TWILIO_NUMBER],
      defaultSenderPhoneNumber: HEARTPLACE_TWILIO_NUMBER,
      clinicPhone: {
        defaultPhoneNumber: HEARTPLACE_TRANSFER_LINE,
        backupPhoneNumber: HEARTPLACE_TRANSFER_LINE,
        preferReceivingLocationPhone: true,
      },
    },
    {
      groupId: GroupIds.USHV_HEARTPLACE_LIVE_SANDBOX,
      inboundPhoneNumbers: [HEARTPLACE_SANDBOX_TWILIO_NUMBER],
      defaultSenderPhoneNumber: HEARTPLACE_SANDBOX_TWILIO_NUMBER,
      clinicPhone: { defaultPhoneNumber: HEARTPLACE_TRANSFER_LINE, preferReceivingLocationPhone: true },
    },
  ],
} as const satisfies CustomerSmsRoutingConfig;
